import React from "react"
import { OrderPaymentKlarnaCheckout } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName,
  getPaymentProviderDisplayName
} from "helpers/getPaymentDisplayName"
import { Container, Label, Row, StatusWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"

type Props = {
  orderPayment: OrderPaymentKlarnaCheckout
}

const Klarna = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row $columns={"1fr 1fr 1fr"}>
          <ListEntry
            label={"Payment provider"}
            value={getPaymentProviderDisplayName(orderPayment.providerName)}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
          {orderPayment.fraudStatus ? (
            <div>
              <Label>Fraud status</Label>
              <StatusWrapper>
                <StatusSmall status={orderPayment.fraudStatus} />
              </StatusWrapper>
            </div>
          ) : (
            <></>
          )}
        </Row>
      </Container>
    </>
  )
}

export default Klarna
